import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private isExpandedSubject = new BehaviorSubject<boolean>(true);
  isExpanded$ = this.isExpandedSubject.asObservable();

  private expandedState = new BehaviorSubject<boolean>(true)
  expandedState$ = this.expandedState.asObservable()

  private manualToggleState = new BehaviorSubject<boolean>(false)
  manualToggleState$ = this.manualToggleState.asObservable()

  setExpandedState(state: boolean) {
    this.isExpandedSubject.next(state);
  }

  toggleExpandedState() {
    this.isExpandedSubject.next(!this.isExpandedSubject.value);
  }

  setManualToggle(state: boolean) {
    this.manualToggleState.next(state)
    localStorage.setItem('sidebar-manual-toggle', JSON.stringify(state))
  }

  getManualToggle(): boolean {
    const saved = localStorage.getItem('sidebar-manual-toggle')
    return saved ? JSON.parse(saved) : this.manualToggleState.value
  }
}
